
import React, { createContext, useState, useEffect } from "react";

//import { Plugins } from '@capacitor/core';

import { Preferences } from '@capacitor/preferences'

//const { Storage } = Plugins;

import Cookie from 'universal-cookie';


let cookies = new Cookie();

async function removeStorageCredentials() {


    await Preferences.remove({ key: 'customerID' });
    await Preferences.remove({ key: 'customer_first_name' });
    await Preferences.remove({ key: 'customer_last_name' });
    await Preferences.remove({ key: 'customer_company' });
    await Preferences.remove({ key: 'customer_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });


    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

async function getStorageCredentials() {

    //alert('In getStorageCredentials Client');

    const  stored_accountID  = await Preferences.get({ key: 'accountID' });
    const  stored_schemaName  = await Preferences.get({ key: 'schemaName' });
    const  stored_isAuthenticated  = await Preferences.get({ key: 'isAuthenticated' });
    const  stored_accessRights  = await Preferences.get({ key: 'accessRights' });
    const  stored_loginUsername_Authenticated  = await Preferences.get({ key: 'loginUsername_Authenticated' });
    const  stored_loginPassword_Authenticated  = await Preferences.get({ key: 'loginPassword_Authenticated' });
    const  stored_baseURL_Authenticated  = await Preferences.get({ key: 'baseURL_Authenticated' });


    let storageObjects = {
        accountID: stored_accountID.value,
        schemaName: stored_schemaName.value,
        isAuthenticated: stored_isAuthenticated.value,
        accessRights: stored_accessRights.value,
        loginUsername_Authenticated: stored_loginUsername_Authenticated.value,
        loginPassword_Authenticated: stored_loginPassword_Authenticated.value,
        baseURL_Authenticated: stored_baseURL_Authenticated.value,
    }

    return storageObjects;
}

export const Auth_ClientID_context = createContext({
    acctID: null,
    schema: null,
    accessRights: [],
    cookieID: null,
    authenticated: null,
    loginUsername: null,
    loginPassword: null,
    startDate: new Date(),
    endDate: new Date(),
    numOfNights: null,
    baseURL: null,
    changeAccountID: (data_id) => {},
    changeSchema: (data_schema) => {},
    changeAccessRights: (data_accessRights) => {},
    changeCookieID: (data_schema) => {},
    changeAuthenticated: (data_auth) => {},
    changeLoginUsername: (data_username) => {},
    changeLoginPassword: (data_password) => {},
    changeStartDateRange: (data_startDate) => {},
    changeEndDateRange: (data_endDate) => {},
    changeNumOfNights: (data_numOfNights) => {},
    changeBaseURL: (data_baseURL) => {},

});

export function AuthenticatedClientProvider (props) {

    //alert('In AuthenticatedMerchantProvider');

    const [accountID, setAccountID ] = useState(null);
    const [schemaName, setSchemaName ] = useState(null);
    const [accessRightsData, setAccessRights ] = useState([]);
    const [cookieIdentity, setCookieIdentity ] = useState(null);
    const [isAuthenticated, setIsAuthenticated ] = useState(null);
    const [loginUsername_Authenticated, setLoginUsername ] = useState(null);
    const [loginPassword_Authenticated, setLoginPassword ] = useState(null);
    const [startDateRange, setStartDateRange ] = useState(new Date());
    const [endDateRange, setEndDateRange ] = useState(new Date());
    const [numberOfNights, setNumberOfNights ] = useState(null);
    const [baseURL, setBaseURL ] = useState(null);

    
    /* useEffect(() => {

        //removeStorageCredentials();

       getStorageCredentials().then(res => { 

                setAccountID(res.accountID);
                setSchemaName(res.schemaName);
                setIsAuthenticated(res.isAuthenticated);
                setLoginUsername(res.loginUsername_Authenticated);
                setLoginPassword(res.loginPassword_Authenticated);
                setAccessRights(res.accessRights);
                setBaseURL(res.baseURL_Authenticated);

        });

    }, [])*/

    function changeAccountIDHandler (data_id) {

        //alert('In changeAccountIDHandler');

        setAccountID((prev) => { return data_id} );
        //setAccountID(data_id);
    }

    function changeSchemaNameHandler (data_schema) {

        setSchemaName((prev) => { return data_schema} );
        //setSchemaName(data_schema);
    }

    function changeAccessRightsHandler (data_accessRights) {

        setAccessRights((prev) => { return data_accessRights} );
        //setAccessRights(data_accessRights);
    }

    function changeCookieHandler(data_cookie) {

        setCookieIdentity((prev) => { return data_cookie} );
        //setCookieIdentity(data_cookie);
    }


    function changeAuthenticatedHandler(data_auth) {

        setIsAuthenticated((prev) => { return data_auth} );
        //setIsAuthenticated(data_auth);
    }


    function changeLoginUsernameHandler(data_username) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setLoginUsername(data_username);
    }


    function changeLoginPasswordHandler(data_password) {

        //setIsAuthenticated((prev) => { return data_auth} );
        setLoginPassword(data_password);
    }

    function changeStartDateRangeHandler(data_startDate) {

        setStartDateRange((prev) => { return data_startDate} );
        //setIsAuthenticated(data_auth);
    }

    function changeEndDateRangeHandler(data_endDate) {

        setEndDateRange((prev) => { return data_endDate} );
        //setIsAuthenticated(data_auth);
    }

    function changeNumOfNightsHandler(data_numOfNights) {

        setNumberOfNights((prev) => { return data_numOfNights} );
        //setIsAuthenticated(data_auth);
    }

    function changeBaseURLHandler(data_baseURL) {

        setBaseURL((prev) => { return data_baseURL} );
        //setIsAuthenticated(data_auth);
    }

    const context = {
        acctID: accountID,
        schema: schemaName,
        accessRights: accessRightsData,
        cookieID: cookieIdentity,
        authenticated: isAuthenticated,
        loginUsername: loginUsername_Authenticated,
        loginPassword: loginPassword_Authenticated,
        startDate: startDateRange,
        endDate: endDateRange,
        numOfNights: numberOfNights,
        baseURL: baseURL,
        changeAccountID: changeAccountIDHandler,
        changeSchema: changeSchemaNameHandler,
        changeAccessRights: changeAccessRightsHandler,
        changeCookieID: changeCookieHandler,
        changeAuthenticated: changeAuthenticatedHandler,
        changeLoginUsername: changeLoginUsernameHandler,
        changeLoginPassword: changeLoginPasswordHandler,
        changeStartDateRange: changeStartDateRangeHandler,
        changeEndDateRange: changeEndDateRangeHandler,
        changeNumOfNights: changeNumOfNightsHandler,
        changeBaseURL: changeBaseURLHandler,

    }

    return <Auth_ClientID_context.Provider value={context}>
        {props.children}
    </Auth_ClientID_context.Provider>
    
    }
    
    